// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainInfoBlock__container-e4089f {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background-color: var(--base-0);
}

.MainInfoBlock__info-block-c38b85 {
  --info-block-text-color: var(--addition-50);
  background: var(--average-background);
}`, "",{"version":3,"sources":["webpack://./src/main/MainInfoBlock/MainInfoBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;AACF;;AAEA;EACE,2CAAA;EACA,qCAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  background-color: var(--base-0);\n}\n\n.info-block {\n  --info-block-text-color: var(--addition-50);\n  background: var(--average-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MainInfoBlock__container-e4089f`,
	"info-block": `MainInfoBlock__info-block-c38b85`,
	"infoBlock": `MainInfoBlock__info-block-c38b85`
};
module.exports = ___CSS_LOADER_EXPORT___;
